export default "__VITE_ASSET__DR4Za_bS__"